import BaseService from "./BaseService";
import AppUtils from "../utils/BaseUtils/AppUtils";

class MessageRequestServices extends BaseService {
  createMessageRequest(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.messageRequest.CREATE_MESSAGE_REQUEST,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  acceptMessageRequest(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.messageRequest.ACCEPT_MESSAGE_REQUEST,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  declineMessageRequest(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.messageRequest.DECLINE_MESSAGE_REQUEST,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
}

export default MessageRequestServices;
